import React from 'react';
import { LayoutDashboard, ExternalLink, Users, Calendar } from 'lucide-react';
export function BoardOverviewArtifact({
  data
}: {
  data: any[];
}) {
  if (!Array.isArray(data) || data.length === 0) {
    return <div className="p-4 text-slate-500 text-sm" data-id="element-63">
        No hay tableros para mostrar.
      </div>;
  }
  return <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4" data-id="element-64">
      {data.map((board, idx) => {
      const name = board.name || 'Tablero';
      const type = board.type || 'scrum';
      const id = board.id;
      const location = board.location?.projectName || board.location?.name;
      return <div key={id || idx} className="bg-slate-900 rounded-xl border border-slate-800 p-5 hover:border-indigo-500/50 transition-colors group" data-id="element-65">
            <div className="flex justify-between items-start mb-4" data-id="element-66">
              <div className="flex items-center gap-3" data-id="element-67">
                <div className={`p-2.5 rounded-lg ${type === 'scrum' ? 'bg-indigo-900/50 text-indigo-400' : 'bg-emerald-900/50 text-emerald-400'}`} data-id="element-68">
                  <LayoutDashboard size={20} data-id="element-69" />
                </div>
                <div data-id="element-70">
                  <h3 className="font-bold text-slate-100 group-hover:text-indigo-300 transition-colors flex items-center gap-1.5" data-id="element-71">
                    {name}
                    <ExternalLink size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-72" />
                  </h3>
                  <p className="text-xs text-slate-500 mt-0.5 flex items-center gap-1.5" data-id="element-73">
                    <span className="uppercase tracking-wider font-semibold" data-id="element-74">
                      {type}
                    </span>
                    {location && <>
                        <span className="w-1 h-1 rounded-full bg-slate-700" data-id="element-75" />
                        <span className="truncate max-w-[120px]" title={location} data-id="element-76">
                          {location}
                        </span>
                      </>}
                  </p>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-between mt-5 pt-4 border-t border-slate-800/50" data-id="element-77">
              <div className="flex items-center gap-4" data-id="element-78">
                <div className="flex items-center gap-1.5 text-xs text-slate-400" data-id="element-79">
                  <Users size={14} data-id="element-80" />
                  <span data-id="element-81">Equipo</span>
                </div>
                {type === 'scrum' && <div className="flex items-center gap-1.5 text-xs text-slate-400" data-id="element-82">
                    <Calendar size={14} data-id="element-83" />
                    <span data-id="element-84">Sprints</span>
                  </div>}
              </div>
              <span className="text-[10px] font-mono text-slate-600 bg-slate-950 px-2 py-1 rounded border border-slate-800" data-id="element-85">
                ID: {id}
              </span>
            </div>
          </div>;
    })}
    </div>;
}